import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { TooltipContainer, TooltipText, TooltipFloating } from './style';

export const getTooltipPosition = (
  clientX: number,
  clientY: number,
  content: string,
  maxWidth = 360,
  rowHeight = 22,
  padding = 16,
  targetRect?: DOMRect,
  maxHeight = 280,
  verticalGap = 4,
) => {
  const items = content.split('\n')
  const numLines = items.length
  const estimatedHeight = Math.min(500, Math.max(40, numLines * rowHeight + padding))
  const tooltipHeight = Math.min(estimatedHeight, maxHeight)
  const tooltipWidth = Math.min(maxWidth, window.innerWidth - 16)

  let left = clientX + 12
  let translateX = 0
  if (left + tooltipWidth > window.innerWidth) {
    left = clientX - 12
    translateX = -100
  }
  if (left < 8) {
    left = 8
    translateX = 0
  }

  let top = clientY - 12
  let translateY = -100
  if (clientY - tooltipHeight - 12 < 8) {
    top = clientY + 12
    translateY = 0
  }

  return {
    x: left,
    y: top,
    transform: `translate(${translateX}%, ${translateY}%)`,
  }
}

interface TooltipProps {
  text: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <TooltipContainer
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && text && <TooltipText>{text}</TooltipText>}
    </TooltipContainer>
  );
};

interface FloatingTooltipProps {
  visible: boolean;
  x: number;
  y: number;
  transform?: string;
  children: React.ReactNode;
}

export const FloatingTooltip: React.FC<FloatingTooltipProps> = ({ visible, x, y, transform, children }) => {
  if (!visible) return null

  return ReactDOM.createPortal(
    <TooltipFloating data-tooltip-floating style={{ left: x, top: y, transform }}>
      {children}
    </TooltipFloating>,
    document.body,
  )
}

export default Tooltip; 